export default "__VITE_ASSET__DwA9nQw2__"